import { type IconsConfig } from "react-better-html";

export const emptyIcon = {
   width: 256,
   height: 256,
   paths: [
      {
         d: "",
         type: "fill",
      },
   ],
};

export const icons: Partial<IconsConfig> = {
   arrowLeft: {
      width: 448,
      height: 512,
      paths: [
         {
            d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z",
            type: "fill",
         },
      ],
   },
   arrowBendDownLeft: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M236,56A108.12,108.12,0,0,1,128,164H61l27.52,27.51a12,12,0,0,1-17,17l-48-48a12,12,0,0,1,0-17l48-48a12,12,0,0,1,17,17L61,140h67a84.09,84.09,0,0,0,84-84,12,12,0,0,1,24,0Z",
            type: "fill",
         },
      ],
   },
   externalLink: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M204,64V168a12,12,0,0,1-24,0V93L72.49,200.49a12,12,0,0,1-17-17L163,76H88a12,12,0,0,1,0-24H192A12,12,0,0,1,204,64Z",
            type: "fill",
         },
      ],
   },
   code: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M71.68,97.22,34.74,128l36.94,30.78a12,12,0,1,1-15.36,18.44l-48-40a12,12,0,0,1,0-18.44l48-40A12,12,0,0,1,71.68,97.22Zm176,21.56-48-40a12,12,0,1,0-15.36,18.44L221.26,128l-36.94,30.78a12,12,0,1,0,15.36,18.44l48-40a12,12,0,0,0,0-18.44ZM164.1,28.72a12,12,0,0,0-15.38,7.18l-64,176a12,12,0,0,0,7.18,15.37A11.79,11.79,0,0,0,96,228a12,12,0,0,0,11.28-7.9l64-176A12,12,0,0,0,164.1,28.72Z",
            type: "fill",
         },
      ],
   },
   plus: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M228,128a12,12,0,0,1-12,12H140v76a12,12,0,0,1-24,0V140H40a12,12,0,0,1,0-24h76V40a12,12,0,0,1,24,0v76h76A12,12,0,0,1,228,128Z",
            type: "fill",
         },
      ],
   },
   minus: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128Z",
            type: "fill",
         },
      ],
   },
   refresh: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M228,128a100,100,0,0,1-98.66,100H128a99.39,99.39,0,0,1-68.62-27.29,12,12,0,0,1,16.48-17.45,76,76,0,1,0-1.57-109c-.13.13-.25.25-.39.37L54.89,92H72a12,12,0,0,1,0,24H24a12,12,0,0,1-12-12V56a12,12,0,0,1,24,0V76.72L57.48,57.06A100,100,0,0,1,228,128Z",
            type: "fill",
         },
      ],
   },
   house: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M240,204H228V144a12,12,0,0,0,12.49-19.78L142.14,25.85a20,20,0,0,0-28.28,0L15.51,124.2A12,12,0,0,0,28,144v60H16a12,12,0,0,0,0,24H240a12,12,0,0,0,0-24ZM52,121.65l76-76,76,76V204H164V152a12,12,0,0,0-12-12H104a12,12,0,0,0-12,12v52H52ZM140,204H116V164h24Z",
            type: "fill",
         },
      ],
   },
   pen: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M230.14,70.54,185.46,25.85a20,20,0,0,0-28.29,0L33.86,149.17A19.85,19.85,0,0,0,28,163.31V208a20,20,0,0,0,20,20H92.69a19.86,19.86,0,0,0,14.14-5.86L230.14,98.82a20,20,0,0,0,0-28.28ZM91,204H52V165l84-84,39,39ZM192,103,153,64l18.34-18.34,39,39Z",
            type: "fill",
         },
      ],
   },
   logout: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M124,216a12,12,0,0,1-12,12H48a12,12,0,0,1-12-12V40A12,12,0,0,1,48,28h64a12,12,0,0,1,0,24H60V204h52A12,12,0,0,1,124,216Zm108.49-96.49-40-40a12,12,0,0,0-17,17L195,116H112a12,12,0,0,0,0,24h83l-19.52,19.51a12,12,0,0,0,17,17l40-40A12,12,0,0,0,232.49,119.51Z",
            type: "fill",
         },
      ],
   },
   envelope: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M224,44H32A12,12,0,0,0,20,56V192a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V56A12,12,0,0,0,224,44ZM193.15,68,128,127.72,62.85,68ZM44,188V83.28l75.89,69.57a12,12,0,0,0,16.22,0L212,83.28V188Z",
            type: "fill",
         },
      ],
   },
   squares: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M100,36H56A20,20,0,0,0,36,56v44a20,20,0,0,0,20,20h44a20,20,0,0,0,20-20V56A20,20,0,0,0,100,36ZM96,96H60V60H96ZM200,36H156a20,20,0,0,0-20,20v44a20,20,0,0,0,20,20h44a20,20,0,0,0,20-20V56A20,20,0,0,0,200,36Zm-4,60H160V60h36Zm-96,40H56a20,20,0,0,0-20,20v44a20,20,0,0,0,20,20h44a20,20,0,0,0,20-20V156A20,20,0,0,0,100,136Zm-4,60H60V160H96Zm104-60H156a20,20,0,0,0-20,20v44a20,20,0,0,0,20,20h44a20,20,0,0,0,20-20V156A20,20,0,0,0,200,136Zm-4,60H160V160h36Z",
            type: "fill",
         },
      ],
   },
   user: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M234.38,210a123.36,123.36,0,0,0-60.78-53.23,76,76,0,1,0-91.2,0A123.36,123.36,0,0,0,21.62,210a12,12,0,1,0,20.77,12c18.12-31.32,50.12-50,85.61-50s67.49,18.69,85.61,50a12,12,0,0,0,20.77-12ZM76,96a52,52,0,1,1,52,52A52.06,52.06,0,0,1,76,96Z",
            type: "fill",
         },
      ],
   },
   gear: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M128,76a52,52,0,1,0,52,52A52.06,52.06,0,0,0,128,76Zm0,80a28,28,0,1,1,28-28A28,28,0,0,1,128,156Zm113.86-49.57A12,12,0,0,0,236,98.34L208.21,82.49l-.11-31.31a12,12,0,0,0-4.25-9.12,116,116,0,0,0-38-21.41,12,12,0,0,0-9.68.89L128,37.27,99.83,21.53a12,12,0,0,0-9.7-.9,116.06,116.06,0,0,0-38,21.47,12,12,0,0,0-4.24,9.1l-.14,31.34L20,98.35a12,12,0,0,0-5.85,8.11,110.7,110.7,0,0,0,0,43.11A12,12,0,0,0,20,157.66l27.82,15.85.11,31.31a12,12,0,0,0,4.25,9.12,116,116,0,0,0,38,21.41,12,12,0,0,0,9.68-.89L128,218.73l28.14,15.74a12,12,0,0,0,9.7.9,116.06,116.06,0,0,0,38-21.47,12,12,0,0,0,4.24-9.1l.14-31.34,27.81-15.81a12,12,0,0,0,5.85-8.11A110.7,110.7,0,0,0,241.86,106.43Zm-22.63,33.18-26.88,15.28a11.94,11.94,0,0,0-4.55,4.59c-.54,1-1.11,1.93-1.7,2.88a12,12,0,0,0-1.83,6.31L184.13,199a91.83,91.83,0,0,1-21.07,11.87l-27.15-15.19a12,12,0,0,0-5.86-1.53h-.29c-1.14,0-2.3,0-3.44,0a12.08,12.08,0,0,0-6.14,1.51L93,210.82A92.27,92.27,0,0,1,71.88,199l-.11-30.24a12,12,0,0,0-1.83-6.32c-.58-.94-1.16-1.91-1.7-2.88A11.92,11.92,0,0,0,63.7,155L36.8,139.63a86.53,86.53,0,0,1,0-23.24l26.88-15.28a12,12,0,0,0,4.55-4.58c.54-1,1.11-1.94,1.7-2.89a12,12,0,0,0,1.83-6.31L71.87,57A91.83,91.83,0,0,1,92.94,45.17l27.15,15.19a11.92,11.92,0,0,0,6.15,1.52c1.14,0,2.3,0,3.44,0a12.08,12.08,0,0,0,6.14-1.51L163,45.18A92.27,92.27,0,0,1,184.12,57l.11,30.24a12,12,0,0,0,1.83,6.32c.58.94,1.16,1.91,1.7,2.88A11.92,11.92,0,0,0,192.3,101l26.9,15.33A86.53,86.53,0,0,1,219.23,139.61Z",
            type: "fill",
         },
      ],
   },
   bell: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M225.29,165.93C216.61,151,212,129.57,212,104a84,84,0,0,0-168,0c0,25.58-4.59,47-13.27,61.93A20.08,20.08,0,0,0,30.66,186,19.77,19.77,0,0,0,48,196H84.18a44,44,0,0,0,87.64,0H208a19.77,19.77,0,0,0,17.31-10A20.08,20.08,0,0,0,225.29,165.93ZM128,212a20,20,0,0,1-19.6-16h39.2A20,20,0,0,1,128,212ZM54.66,172C63.51,154,68,131.14,68,104a60,60,0,0,1,120,0c0,27.13,4.48,50,13.33,68Z",
            type: "fill",
         },
      ],
   },
   star4: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M240,128a15.79,15.79,0,0,1-10.5,15l-63.44,23.07L143,229.5a16,16,0,0,1-30,0L89.94,166.06,26.5,143a16,16,0,0,1,0-30L89.94,89.94,113,26.5a16,16,0,0,1,30,0l23.07,63.44L229.5,113A15.79,15.79,0,0,1,240,128Z",
            type: "fill",
         },
      ],
   },
   star4Outline: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M230.86,109.25,169.18,86.82,146.75,25.14a19.95,19.95,0,0,0-37.5,0L86.82,86.82,25.14,109.25a19.95,19.95,0,0,0,0,37.5l61.68,22.43,22.43,61.68a19.95,19.95,0,0,0,37.5,0l22.43-61.68,61.68-22.43a19.95,19.95,0,0,0,0-37.5Zm-75.14,39.29a12,12,0,0,0-7.18,7.18L128,212.21l-20.54-56.49a12,12,0,0,0-7.18-7.18L43.79,128l56.49-20.54a12,12,0,0,0,7.18-7.18L128,43.79l20.54,56.49a12,12,0,0,0,7.18,7.18L212.21,128Z",
            type: "fill",
         },
      ],
   },
   support: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M204.73,51.85A108.07,108.07,0,0,0,20,128v56a28,28,0,0,0,28,28H64a28,28,0,0,0,28-28V144a28,28,0,0,0-28-28H44.84A84.05,84.05,0,0,1,128,44h.64a83.7,83.7,0,0,1,82.52,72H192a28,28,0,0,0-28,28v40a28,28,0,0,0,28,28h19.6A20,20,0,0,1,192,228H136a12,12,0,0,0,0,24h56a44.05,44.05,0,0,0,44-44V128A107.34,107.34,0,0,0,204.73,51.85ZM64,140a4,4,0,0,1,4,4v40a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V140Zm124,44V144a4,4,0,0,1,4-4h20v48H192A4,4,0,0,1,188,184Z",
            type: "fill",
         },
      ],
   },
   folder: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M216,68H133.39l-26-29.29a20,20,0,0,0-15-6.71H40A20,20,0,0,0,20,52V200.62A19.41,19.41,0,0,0,39.38,220H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68ZM44,56H90.61l10.67,12H44ZM212,196H44V92H212Z",
            type: "fill",
         },
      ],
   },
   parking: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm8-136H104A12,12,0,0,0,92,88v80a12,12,0,0,0,24,0V156h20a40,40,0,0,0,0-80Zm0,56H116V100h20a16,16,0,0,1,0,32Z",
            type: "fill",
         },
      ],
   },
   garage: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M240,188h-4V98.67A20,20,0,0,0,227.09,82l-88-58.66a19.94,19.94,0,0,0-22.18,0L28.91,82A20,20,0,0,0,20,98.67V188H16a12,12,0,0,0,0,24H240a12,12,0,0,0,0-24ZM44,100.81l84-56,84,56V188H196V120a12,12,0,0,0-12-12H72a12,12,0,0,0-12,12v68H44ZM172,132v16H140V132Zm-56,16H84V132h32ZM84,172h32v16H84Zm56,0h32v16H140Z",
            type: "fill",
         },
      ],
   },
   balcony: {
      width: 256,
      height: 247,
      paths: [
         {
            d: "M217.221 149.578H244.337C250.708 149.578 256 154.581 256 160.894C256 167.207 250.708 172.211 244.337 172.211H243.074V224.367H244.337C250.708 224.367 256 229.37 256 235.683C256 241.996 250.708 247 244.337 247H11.6635C5.29165 247 0 241.996 0 235.683C0 229.37 5.29165 224.367 11.6635 224.367H12.926V172.211H11.6635C5.29165 172.211 0 167.207 0 160.894C0 154.581 5.29165 149.578 11.6635 149.578H38.7788V36.246C38.779 16.1843 55.6657 0 76.2952 0H179.705C200.334 0 217.221 16.1843 217.221 36.246V149.578ZM193.893 36.246C193.893 28.8107 187.59 22.6335 179.705 22.6335H76.2952C68.4097 22.6335 62.1069 28.8107 62.1067 36.246V149.578H193.893V36.246ZM191.369 224.367H219.746V172.211H191.369V224.367ZM36.2538 224.367H64.6308V172.211H36.2538V224.367ZM139.663 224.367H168.041V172.211H139.663V224.367ZM87.9587 224.367H116.337V172.211H87.9587V224.367Z",
            type: "fill",
         },
      ],
   },
   arch: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M180.291 27.5302H245.004C247.92 27.5302 250.718 28.6893 252.78 30.7514C254.842 32.8135 256 35.6103 256 38.5265V66.0567C256 68.9729 254.842 71.7696 252.78 73.8318C250.718 75.8939 247.92 77.0529 245.004 77.0529H228.47V234.008H231.239C234.155 234.008 236.952 235.167 239.014 237.229C241.076 239.291 242.234 242.088 242.234 245.004C242.234 247.92 241.076 250.718 239.014 252.78C236.952 254.842 234.155 256 231.239 256H155.53C152.614 256 149.817 254.842 147.755 252.78C145.693 250.718 144.534 247.92 144.534 245.004C144.534 242.088 145.693 239.291 147.755 237.229C149.817 235.167 152.614 234.008 155.53 234.008H158.3V125.959C149.796 118.911 139.083 115.033 128 115.033C116.917 115.033 106.204 118.911 97.7004 125.959V234.008H100.47C103.386 234.008 106.183 235.167 108.245 237.229C110.307 239.291 111.466 242.088 111.466 245.004C111.466 247.92 110.307 250.718 108.245 252.78C106.183 254.842 103.386 256 100.47 256H24.7609C21.8448 256 19.0479 254.842 16.9858 252.78C14.9237 250.718 13.7656 247.92 13.7656 245.004C13.7657 242.088 14.9238 239.291 16.9858 237.229C19.0479 235.167 21.8447 234.008 24.7609 234.008H27.5302V77.0529H10.9962C8.07989 77.0529 5.28237 75.8939 3.22023 73.8318C1.15831 71.7697 0 68.9729 0 66.0567V38.5265C0 35.6103 1.15834 32.8135 3.22023 30.7514C5.28238 28.6893 8.07989 27.5302 10.9962 27.5302H75.7089V10.9962C75.7089 8.07989 76.867 5.28237 78.9291 3.22023C80.9912 1.15828 83.788 8.40839e-05 86.7042 0H169.296C172.212 8.21293e-05 175.009 1.15828 177.071 3.22023C179.133 5.28238 180.291 8.0799 180.291 10.9962V27.5302ZM78.9291 113.343C76.8676 115.405 75.7096 118.201 75.7089 121.116V234.008H49.5227V77.0529H206.477V234.008H180.291V121.116C180.29 118.2 179.129 115.401 177.067 113.339L176.453 112.734C163.491 100.119 146.11 93.0483 128 93.0482C109.603 93.0482 91.9528 100.349 78.9291 113.343ZM158.3 21.9924H97.7004V38.5265C97.7004 41.4426 96.5421 44.2394 94.4802 46.3015C92.418 48.3637 89.6205 49.5227 86.7042 49.5227H21.9924V55.0605H234.008V49.5227H169.296C166.38 49.5227 163.582 48.3637 161.52 46.3015C159.458 44.2394 158.3 41.4426 158.3 38.5265V21.9924Z",
            type: "fill",
            fillRule: "evenodd",
            clipRule: "evenodd",
         },
      ],
   },
   roof: {
      width: 256,
      height: 113,
      paths: [
         {
            d: "M191.042 4.32635C189.213 1.61972 186.151 0.000156428 182.883 0H73.1127C69.7558 4.21962e-05 66.751 1.68973 64.9593 4.31786L64.9527 4.32635L1.6877 97.6725C-1.35315 102.162 -0.173201 108.268 4.3288 111.307C8.83772 114.351 14.9557 113.166 17.9992 108.673L73.1127 27.3512L128.218 108.673C130.047 111.38 133.11 113 136.378 113H246.147C249.806 113 253.15 110.979 254.859 107.767C256.502 104.666 256.362 100.928 254.494 97.9563L254.307 97.6715L191.042 4.32635ZM130.161 19.6435L180.112 93.3565H192.589L142.629 19.6435H130.161ZM156.341 93.3565H141.602L91.6421 19.6435H106.391L156.341 93.3565ZM227.616 93.3565H216.358L166.397 19.6435H177.655L227.616 93.3565Z",
            type: "fill",
            fillRule: "evenodd",
            clipRule: "evenodd",
         },
      ],
   },
   fence: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M242.896 66.172C250.454 68.2743 256 75.2072 256 83.4361V111.838H255.325C253.649 117.865 248.903 122.612 242.876 124.289V157.912C250.434 160.014 255.979 166.946 255.979 175.175V198.765C255.979 206.994 250.434 213.926 242.876 216.028V235.461C242.876 246.791 233.668 256 222.339 256H190.889C179.56 256 170.353 246.791 170.352 235.461V216.683H164.252V235.461C164.252 246.791 155.044 256 143.714 256H112.265C100.936 256 91.7285 246.791 91.7284 235.461V216.683H85.6278V235.461C85.6277 246.791 76.4195 256 65.0902 256H33.641C22.3117 256 13.1045 246.791 13.1043 235.461V216.028C5.54591 213.926 0 206.994 0 198.765V175.175C0.000197942 166.946 5.54594 160.014 13.1043 157.912V124.289C5.54606 122.186 0.000178135 115.255 0 107.026V83.4361C0 75.2072 5.54578 68.2743 13.1043 66.172V36.2557C13.1043 33.5577 14.1848 31.0316 16.0592 29.157L42.2669 2.94552C46.0681 -0.866462 52.1692 -0.971216 56.11 2.58931L56.485 2.94552L82.6156 29.1213C84.5446 31.0108 85.6071 33.5866 85.6071 36.2557V65.5179H91.7077V36.2557C91.7077 33.5577 92.7883 31.0316 94.6626 29.157L120.862 2.95491C124.785 -0.988628 131.166 -0.976957 135.088 2.94552L161.26 29.1213C163.189 31.0108 164.252 33.5866 164.252 36.2557V65.5179H170.352V36.2557C170.352 33.5577 171.433 31.0316 173.307 29.157L199.515 2.94552C203.439 -0.989526 209.814 -0.974143 213.733 2.94552L239.941 29.157C241.847 31.0433 242.896 33.6028 242.896 36.2557V66.172ZM65.4117 235.763C65.5008 235.674 65.5404 235.571 65.5404 235.461V216.683H33.2312V235.461C33.2313 235.571 33.2717 235.674 33.3609 235.763C33.4499 235.852 33.5523 235.891 33.6607 235.891H65.1109C65.2196 235.891 65.3225 235.852 65.4117 235.763ZM65.5404 157.258H33.2312V124.944H65.5404V157.258ZM91.7481 157.258H85.6476V124.944H91.7481V157.258ZM144.164 124.944V157.258H111.856V124.944H144.164ZM170.372 157.258H164.272V124.944H170.372V157.258ZM222.789 124.944V157.258H190.48V124.944H222.789ZM20.1278 196.574V177.367H235.893V196.574H20.1278ZM20.1278 104.835V85.6269H235.893V104.835H20.1278ZM190.48 65.5179V40.4173L206.633 24.2613L222.789 40.4173V65.5179H190.48ZM144.036 235.763C144.125 235.674 144.164 235.571 144.164 235.461V216.683H111.856V235.461C111.856 235.571 111.896 235.674 111.985 235.763C112.074 235.852 112.177 235.891 112.286 235.891H143.735C143.844 235.891 143.947 235.852 144.036 235.763ZM222.66 235.763C222.749 235.674 222.788 235.571 222.789 235.461V216.683H190.48V235.461C190.48 235.571 190.52 235.674 190.609 235.763C190.698 235.852 190.801 235.891 190.91 235.891H222.359C222.468 235.891 222.571 235.852 222.66 235.763ZM49.3853 24.2613L33.2312 40.4183V65.5179H65.5404V40.4183L49.3853 24.2613ZM128.009 24.2613L111.856 40.4173V65.5179H144.164V40.4183L128.009 24.2613Z",
            type: "fill",
            fillRule: "evenodd",
            clipRule: "evenodd",
         },
      ],
   },
   stairs: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M252,56a12,12,0,0,1-12,12H196v36a12,12,0,0,1-12,12H140v36a12,12,0,0,1-12,12H84v36a12,12,0,0,1-12,12H16a12,12,0,0,1,0-24H60V152a12,12,0,0,1,12-12h44V104a12,12,0,0,1,12-12h44V56a12,12,0,0,1,12-12h56A12,12,0,0,1,252,56Z",
            type: "fill",
         },
      ],
   },
   package: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M225.6,62.64l-88-48.17a19.91,19.91,0,0,0-19.2,0l-88,48.17A20,20,0,0,0,20,80.19v95.62a20,20,0,0,0,10.4,17.55l88,48.17a19.89,19.89,0,0,0,19.2,0l88-48.17A20,20,0,0,0,236,175.81V80.19A20,20,0,0,0,225.6,62.64ZM128,36.57,200,76,178.57,87.73l-72-39.42Zm0,78.83L56,76,81.56,62l72,39.41ZM44,96.79l72,39.4v76.67L44,173.44Zm96,116.07V136.19l24-13.13V152a12,12,0,0,0,24,0V109.92l24-13.13v76.65Z",
            type: "fill",
         },
      ],
   },
   toilet: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M128,68a12,12,0,0,1-12,12H100a12,12,0,0,1,0-24h16A12,12,0,0,1,128,68Zm48.15,127.62,3.65,25.55A20,20,0,0,1,160,244H96a20,20,0,0,1-19.8-22.83l3.65-25.55A100.08,100.08,0,0,1,28,108,12,12,0,0,1,40,96H52V40A20,20,0,0,1,72,20H184a20,20,0,0,1,20,20V96h12a12,12,0,0,1,12,12A100.08,100.08,0,0,1,176.15,195.62ZM76,96H180V44H76Zm77.21,108.78a100.3,100.3,0,0,1-50.42,0L100.61,220h54.78ZM203.05,120H53a76,76,0,0,0,150.1,0Z",
            type: "fill",
         },
      ],
   },
   bath: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M240,92H211.3A12,12,0,0,0,200,84H136a12,12,0,0,0-11.3,8H68V52a8,8,0,0,1,8-8,8.5,8.5,0,0,1,8.24,6.39,12,12,0,0,0,23.52-4.78A32.22,32.22,0,0,0,44,52V92H16A12,12,0,0,0,4,104v40a60.07,60.07,0,0,0,56,59.85V216a12,12,0,0,0,24,0V204h88v12a12,12,0,0,0,24,0V203.85A60.07,60.07,0,0,0,252,144V104A12,12,0,0,0,240,92Zm-92,16h40v24H148Zm80,36a36,36,0,0,1-36,36H64a36,36,0,0,1-36-36V116h96v28a12,12,0,0,0,12,12h64a12,12,0,0,0,12-12V116h16Z",
            type: "fill",
         },
      ],
   },
   pool: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M88,149.39a12,12,0,0,0,12-12V136h56v3.29a12,12,0,0,0,24,0V32a12,12,0,0,0-24,0v8H100V32a12,12,0,0,0-24,0V137.39A12,12,0,0,0,88,149.39ZM100,112V100h56v12Zm56-48V76H100V64ZM20,164a12,12,0,0,1,12-12c15.63,0,24,5.55,30.66,10,5.4,3.6,9,6,17.34,6s11.93-2.38,17.34-6c6.69-4.47,15-10,30.65-10s24,5.55,30.66,10c5.41,3.6,9,6,17.35,6s11.94-2.38,17.34-6c6.7-4.47,15-10,30.66-10a12,12,0,0,1,0,24c-8.37,0-11.94,2.38-17.35,6-6.69,4.47-15,10-30.65,10s-24-5.55-30.66-10c-5.41-3.6-9-6-17.35-6s-11.93,2.38-17.34,6c-6.69,4.47-15,10-30.65,10s-24-5.55-30.66-10c-5.4-3.6-9-6-17.34-6A12,12,0,0,1,20,164Zm216,44a12,12,0,0,1-12,12c-8.37,0-11.94,2.38-17.35,6-6.69,4.47-15,10-30.65,10s-24-5.55-30.66-10c-5.41-3.6-9-6-17.35-6s-11.93,2.38-17.34,6c-6.69,4.47-15,10-30.65,10s-24-5.55-30.66-10c-5.4-3.6-9-6-17.34-6a12,12,0,0,1,0-24c15.63,0,24,5.55,30.66,10,5.4,3.6,9,6,17.34,6s11.93-2.38,17.34-6c6.69-4.47,15-10,30.65-10s24,5.55,30.66,10c5.41,3.6,9,6,17.35,6s11.94-2.38,17.34-6c6.7-4.47,15-10,30.66-10A12,12,0,0,1,236,208Z",
            type: "fill",
         },
      ],
   },
   steam: {
      width: 251,
      height: 256,
      paths: [
         {
            d: "M43.6441 148.35C29.8019 138.779 22.5416 126.586 22.5416 114.046C22.5416 101.511 29.7953 89.321 43.632 79.6895C44.9025 78.8955 46.0048 77.8602 46.872 76.6384C47.765 75.3801 48.3924 73.952 48.7142 72.4436C49.0358 70.9353 49.0462 69.3768 48.7444 67.8644C48.4426 66.3522 47.8347 64.9173 46.9586 63.6475C46.0823 62.3774 44.9552 61.2987 43.6471 60.4787C42.3391 59.6587 40.8773 59.114 39.3511 58.8782C37.8247 58.6424 36.2659 58.7204 34.7708 59.1076C33.3205 59.4831 31.9612 60.1439 30.768 61.047C11.0084 74.747 2.8083e-06 93.5062 0 114.046C0 134.263 10.6658 152.789 29.8549 166.348L30.775 166.99C44.6136 176.559 51.8754 188.781 51.8755 201.322C51.8755 213.863 44.6143 226.057 30.771 235.628L30.7125 235.669L30.6561 235.712C28.3676 237.488 26.8467 240.072 26.4043 242.933C25.962 245.793 26.6312 248.715 28.2758 251.098C29.9203 253.481 32.4157 255.147 35.2505 255.751C38.0854 256.355 41.045 255.852 43.5202 254.345L43.5836 254.306L43.6451 254.263C63.3671 240.629 74.537 221.873 74.537 201.322C74.5369 181.096 63.7454 162.574 44.5632 148.993L43.6441 148.35Z",
            type: "fill",
         },
         {
            d: "M104.368 54.8765C104.368 67.3842 111.656 79.6071 125.53 89.1797C145.293 102.79 156.392 121.641 156.392 142.183C156.392 162.725 145.261 181.508 125.512 195.114C123.626 196.432 121.382 197.141 119.08 197.141C116.663 197.139 114.306 196.364 112.36 194.932C110.415 193.5 108.977 191.485 108.258 189.181C107.538 186.877 107.574 184.403 108.36 182.12C109.145 179.838 110.639 177.865 112.625 176.489C126.468 166.889 133.731 154.635 133.731 142.122C133.731 129.609 126.467 117.357 112.629 107.819C92.8843 94.1909 81.7356 75.735 81.7355 55.0264C81.7355 34.3324 92.8686 15.542 112.628 1.90363L112.675 1.87345C115.155 0.2394 118.177 -0.358704 121.094 0.209589C124.009 0.777936 126.586 2.46691 128.269 4.91145C129.952 7.35582 130.608 10.3618 130.098 13.2841C129.588 16.2066 127.951 18.8142 125.538 20.5451L125.518 20.5592L125.496 20.5742C111.63 30.1124 104.368 42.3637 104.368 54.8765Z",
            type: "fill",
            fillRule: "evenodd",
            clipRule: "evenodd",
         },
         {
            d: "M219.609 145.672C206.166 136.203 199.155 124.168 199.155 111.819C199.155 99.2759 206.387 87.0826 220.256 77.5136C221.508 76.6989 222.588 75.6476 223.431 74.4153C224.291 73.1584 224.887 71.741 225.187 70.2486C225.487 68.7561 225.483 67.2186 225.175 65.7278C224.867 64.237 224.262 62.8234 223.395 61.5712C222.529 60.3189 221.418 59.2539 220.13 58.4396C218.842 57.6254 217.404 57.0786 215.9 56.8321C214.396 56.5856 212.857 56.6444 211.376 57.0051C209.925 57.3586 208.559 57.9962 207.355 58.8782L206.437 59.521C187.287 73.0984 176.463 91.5895 176.463 111.819C176.463 132.368 187.631 151.155 207.357 164.761C221.224 174.328 228.458 186.55 228.458 199.095C228.458 211.636 221.228 223.827 207.363 233.395C205.367 234.763 203.863 236.735 203.071 239.02C202.279 241.305 202.241 243.783 202.963 246.091C203.685 248.399 205.129 250.415 207.083 251.844C209.029 253.266 211.38 254.03 213.791 254.024C213.794 254.024 213.803 254.023 213.806 254.023H213.819C216.109 254.031 218.345 253.337 220.228 252.035C239.991 238.393 251 219.634 251 199.095C251 178.559 240.022 159.765 220.254 146.121L219.609 145.672Z",
            type: "fill",
            fillRule: "evenodd",
            clipRule: "evenodd",
         },
      ],
   },
   snowflake: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M227.65,149.14a12,12,0,0,1-8.79,14.51l-20.67,5.08,5.4,20.16a12,12,0,0,1-23.18,6.22l-7.29-27.2L140,148.78V187l20.48,20.48a12,12,0,0,1-17,17L128,209l-15.51,15.52a12,12,0,0,1-17-17L116,187V148.78L82.88,167.91l-7.29,27.2a12,12,0,0,1-23.18-6.22l5.4-20.16-20.67-5.08a12,12,0,1,1,5.72-23.3l27.89,6.85L104,128,70.75,108.8l-27.89,6.85A11.8,11.8,0,0,1,40,116a12,12,0,0,1-2.85-23.65l20.67-5.08-5.4-20.16a12,12,0,0,1,23.18-6.22l7.29,27.2L116,107.21V69L95.52,48.48a12,12,0,0,1,17-17L128,47l15.51-15.52a12,12,0,1,1,17,17L140,69v38.24l33.12-19.12,7.29-27.2a12,12,0,0,1,23.18,6.22l-5.4,20.16,20.67,5.08A12,12,0,0,1,216,116a11.8,11.8,0,0,1-2.87-.35l-27.89-6.85L152,128l33.25,19.2,27.89-6.85A12,12,0,0,1,227.65,149.14Z",
            type: "fill",
         },
      ],
   },
   threeDotsHorizontal: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M144,128a16,16,0,1,1-16-16A16,16,0,0,1,144,128ZM60,112a16,16,0,1,0,16,16A16,16,0,0,0,60,112Zm136,0a16,16,0,1,0,16,16A16,16,0,0,0,196,112Z",
            type: "fill",
         },
      ],
   },
   archive: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M224,44H32A20,20,0,0,0,12,64V88a20,20,0,0,0,16,19.6V192a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V107.6A20,20,0,0,0,244,88V64A20,20,0,0,0,224,44ZM36,68H220V84H36ZM52,188V108H204v80Zm112-52a12,12,0,0,1-12,12H104a12,12,0,0,1,0-24h48A12,12,0,0,1,164,136Z",
            type: "fill",
         },
      ],
   },
   trashBin: {
      width: 256,
      height: 256,
      paths: [
         {
            d: "M216,48H180V36A28,28,0,0,0,152,8H104A28,28,0,0,0,76,36V48H40a12,12,0,0,0,0,24h4V208a20,20,0,0,0,20,20H192a20,20,0,0,0,20-20V72h4a12,12,0,0,0,0-24ZM100,36a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4V48H100Zm88,168H68V72H188ZM116,104v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Zm48,0v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Z",
            type: "fill",
         },
      ],
   },
   googleG: {
      width: 488,
      height: 512,
      paths: [
         {
            d: "M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z",
            type: "fill",
         },
      ],
   },
   blob01: {
      width: 256,
      height: 240,
      paths: [
         {
            d: "M251.29 89.4144C267.079 140.048 241.329 202.351 201.482 227.009C161.823 251.667 107.879 238.868 65.2121 208.375C22.5457 177.882 -8.84331 129.695 2.24621 85.2734C13.5237 41.0398 67.0917 0.570716 122.727 0.00603163C178.175 -0.558653 235.502 38.5928 251.29 89.4144Z",
            type: "fill",
         },
      ],
   },
   blob02: {
      width: 256,
      height: 219,
      paths: [
         {
            d: "M253.844 67.1974C264.678 104.964 233.317 151.839 190.171 183.532C146.836 215.225 91.5255 231.546 51.9911 207.444C12.4567 183.153 -11.3019 118.438 5.42418 72.5113C22.1503 26.3949 79.7412 -0.743603 134.861 0.0155147C190.171 0.774633 243.011 29.4313 253.844 67.1974Z",
            type: "fill",
         },
      ],
   },
   blob03: {
      width: 256,
      height: 202,
      paths: [
         {
            d: "M252.604 68.8383C264.305 105.267 244.803 150.861 209.011 177.667C173.22 204.473 121.368 212.263 75.023 184.998C28.9071 157.963 -11.4729 95.8736 2.98131 55.5498C17.4355 14.997 86.4946 -3.56114 142.476 0.562884C198.458 4.91602 241.132 32.1804 252.604 68.8383Z",
            type: "fill",
         },
      ],
   },
   blob04: {
      width: 256,
      height: 202,
      paths: [
         {
            d: "M252.604 68.8383C264.305 105.267 244.803 150.861 209.011 177.667C173.22 204.473 121.368 212.263 75.023 184.998C28.9071 157.963 -11.4729 95.8736 2.98131 55.5498C17.4355 14.997 86.4946 -3.56114 142.476 0.562884C198.458 4.91602 241.132 32.1804 252.604 68.8383Z",
            type: "fill",
         },
      ],
   },
   graphLineDecoration: {
      width: 120,
      height: 30,
      paths: [
         {
            d: "M0,24 20,20 40,22 60,10 80,14 100,6 120,8",
            type: "stroke",
            strokeLinecap: "round",
            strokeLinejoin: "round",
         },
      ],
   },
};
